class ProductVariantSubtitle extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector('[data-product-variant-subtitle-text]');
    this.sectionId = this.dataset.sectionId;
    this.useVariants = this.dataset.useVariants === 'true';
    this.staticText = this.dataset.staticText || '';

    if (!this.useVariants) {
      this.setText(this.staticText);
      return;
    }

    this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event?.data?.sectionId && event.data.sectionId !== this.sectionId) return;

      const variant = event?.data?.variant;
      if (variant?.title) {
        this.setText(variant.title);
      }
    });

    this.setText(this.getInitialVariantTitle() || this.textEl?.textContent?.trim() || '');
  }

  disconnectedCallback() {
    this.variantUnsub?.();
  }

  getProductInfo() {
    return (
      this.closest('product-info') ||
      document.querySelector(`product-info[data-section="${this.sectionId}"]`)
    );
  }

  getInitialVariantTitle() {
    const productInfo = this.getProductInfo();
    const selectedVariantScript = productInfo?.querySelector('[data-selected-variant]');
    if (!selectedVariantScript?.textContent) return '';

    try {
      const variant = JSON.parse(selectedVariantScript.textContent);
      return variant?.title || '';
    } catch (e) {
      return '';
    }
  }

  setText(text) {
    const value = (text || '').trim();
    if (this.textEl) {
      this.textEl.textContent = value;
    }
    this.toggleAttribute('hidden', value === '');
  }
}

if (!customElements.get('product-variant-subtitle')) {
  customElements.define('product-variant-subtitle', ProductVariantSubtitle);
}
